// Standalone bootstrap for the headless render-route. Unlike the live stats
// page (coffee/Backbone drives many ReactDOM.render roots via window.$STATS),
// this mounts ONE root and exposes the window.setChartExportData contract.
// React is 17.0.2 — createRoot comes from the project shim (no react-dom/client).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/01-core-infrastructure.md §4.7

import { createRoot } from '@aytm/lib/common/reactCreateRoot'

import '@aytm/app/stats/page/render-shell/initGlobals' // stub app-level window globals stats components expect (must run first)
import '@aytm/app/stats/page/render-shell/initHighcharts' // activates HC modules (exporting → getSVG) for headless charts
import '@aytm/app/stats/page/render-shell/registerCharts' // populates ExportableCharts registry

import { RenderShell } from '@aytm/app/stats/page/render-shell/RenderShell'

const container = document.querySelector('#root')
if (container) {
  createRoot(container).render(<RenderShell />)
}
